import type { ReactElement } from 'react';
import React from 'react';

import { Box } from '@zillow/constellation';
import { HomePageBannerWrapper, OnsiteMessage } from '@zillow/zrs-cms-messaging';
import { isEmpty } from 'lodash';

import type { getOmpDataQuery } from '../../__generated__/graphql';
import { ompNewLaneProps } from '../../constants/newLane';

const HomePageBanner: React.FC<HomePageBannerProps> = ({
    onsiteMessageData = {},
}): ReactElement | null => {
    if (isEmpty(onsiteMessageData)) {
        return null;
    }
    const triggerProps = ompNewLaneProps.HomePageBanner;
    return (
        <Box data-testid="hops-banner-container">
            <OnsiteMessage
                messageData={onsiteMessageData.onsiteMessage}
                placementName="HomePageBanner"
                // eslint-disable-next-line max-len
                // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment, zillow/@typescript-eslint/naming-convention
                supportedComponents={{ HomePageBannerWrapper }}
                triggerObject={triggerProps.triggerObject}
                triggerLocation={triggerProps.triggerLocation}
                triggerSource={triggerProps.triggerSource}
            />
        </Box>
    );
};

interface HomePageBannerProps {
    onsiteMessageData: getOmpDataQuery | undefined;
}

export default HomePageBanner;
